import ReviewPreview from '@/entities/ReviewPreview/ui/ReviewPreview';
import { ReviewsFilter } from '@/features/product-reviews/ui/ProductReviews';
import { IReview } from '@/shared/api/getProduct/types';
import { FC, useMemo } from 'react';
import { cvaReviewsItems, cvaRoot } from './ReviewsItemsStyles';

interface Props {
  items: IReview[];
  filter: ReviewsFilter;
}

const ReviewsItems: FC<Props> = ({ items, filter }) => {
  const filteredItems = useMemo(() => {
    const filtered = items.filter((item: IReview) => {
      if (filter.type === 'all') {
        return true;
      }
      if (filter.type === 'with_photo') {
        return item.photos.length > 0 || item.photos_before.length > 0 || item.photos_after.length > 0 || item.video;
      }
      return false;
    });

    // TODO: сортировка отзывов
    // if (filter.sort === 'desc') {
    //
    // }
    // if (filter.sort === 'asc') {
    //
    // }

    return filtered;
  }, [items, filter]);
  return (
    <div className={cvaRoot()}>
      <div className={cvaReviewsItems()}>
        {filteredItems?.map((item: IReview) => (
          <ReviewPreview
            key={item.id}
            rating={item.rating}
            name={item.name}
            text={item.text}
            gallery={[
              ...item.photos.map((photo) => ({
                image: photo,
              })),
              ...item.photos_after.map((photo) => ({
                image: photo,
                after: true,
              })),
              ...item.photos_before.map((photo) => ({
                image: photo,
                before: true,
              })),
            ]}
          />
        ))}
      </div>
      {/* <div className={cvaShowMore()}>
        <button
          type={'button'}
          className={cvaShowMoreButton()}
        >
          Загрузить еще{' '}
          <IconPlus
            className={cvaShowMoreButtonIcon()}
          />
        </button>
      </div>
      <ReactPaginate
        breakLabel="..."
        nextLabel=""
        onPageChange={() => {}}
        pageRangeDisplayed={4}
        marginPagesDisplayed={1}
        pageCount={17}
        previousLabel={''}
        renderOnZeroPageCount={null}
        className={cvaPagination()}
        pageClassName={cvaPaginationPage()}
        pageLinkClassName={cvaPaginationLink()}
        activeLinkClassName={cvaPaginationLinkActive()}
        breakClassName={cvaPaginationBreak()}
        breakLinkClassName={cvaPaginationBreakLink()}
      /> */}
    </div>
  );
};

export default ReviewsItems;
